export default __webpack_public_path__ + "static/media/580.3682aa25.png";